export default "__VITE_ASSET__DswuDTHx__"